import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as barcodeActions from "../../../../../actions/barcodeActions";
import * as stockActions from "../../../../../actions/stockActions";

import Button from "../../../../global/generic/Button";
import Modal from "../../../../global/generic/Modal";
import Table, {TABLE_VARIANT_SECONDARY} from "../../../../global/generic/Table";
import BarcodeImage from "../../../../global/BarcodeImage";

class ManualOrderStockModal extends Component {
    constructor(props) {
        super(props);

        this.loadBarcodeImage(this.props.cart.colorantPackages[0]);

        this.state = {
            step: 0
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseManualOrderStockModalAction();
    };

    handleConfirmClick = () => {
        this.props.cart.colorantPackages[this.state.step].confirmed = true;
        this.props.dispatchSaveStockCartAction(this.props.cart);
        this.handleNextClick();
    };

    handleNextClick = () => {
        if (this.state.step + 1 < this.props.cart.colorantPackages.length) {
            this.loadBarcodeImage(this.props.cart.colorantPackages[this.state.step + 1]);
        }
        this.setState({
            step: this.state.step + 1
        });
    };

    handlePreviousClick = () => {
        this.loadBarcodeImage(this.props.cart.colorantPackages[this.state.step - 1]);
        this.setState({
            step: this.state.step - 1
        });
    };

    handleSubmit = () => {
        this.props.dispatchAddColorantPackagesOrdersAction(
            this.props.cart.colorantPackages.filter((colorantPackageStock) => colorantPackageStock.confirmed)
        );
    };

    loadBarcodeImage = (colorantPackageStock) => {
        this.props.dispatchGetBarcodeAction({
            colorant: colorantPackageStock.colorant,
            package: colorantPackageStock.package
        });
    };

    getHeader = () => {
        if (this.state.step < this.props.cart.colorantPackages.length) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <strong>
                        <Translate
                            value="stock.manualOrderProgress"
                            step={this.state.step + 1}
                            total={this.props.cart.colorantPackages.length}
                        />
                    </strong>
                    &nbsp;&gt;&nbsp;
                    <Translate value="general.summary" />
                </React.Fragment>
            );
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <Translate
                    value="stock.manualOrderProgress"
                    step={this.state.step}
                    total={this.props.cart.colorantPackages.length}
                />
                &nbsp;&gt;&nbsp;
                <strong>
                    <Translate value="general.summary" />
                </strong>
            </React.Fragment>
        );
    };

    getColorantInfo = () => {
        return (
            <React.Fragment>
                <div className="col-12 flex background-light-blue padding-15">
                    <div className="flex flex-column font-2_5vh">
                        <span>
                            <span className="color-dark-blue">
                                <Translate value="general.colorant" />
                            </span>
                            &emsp;
                            {this.props.cart.colorantPackages[this.state.step].colorant}
                            &emsp;
                            <span className="color-light-blue font-2vh">
                                ({this.props.cart.colorantPackages[this.state.step].database})
                            </span>
                        </span>
                        <span>
                            <span className="color-dark-blue">
                                <Translate value="stock.toOrder" />
                            </span>
                            &emsp;
                            {this.props.cart.colorantPackages[this.state.step].value}
                        </span>
                    </div>
                    <div className="fill-flex-space flex flex-end flex-align-center-vertical font-3vh">
                        {this.props.cart.colorantPackages[this.state.step].confirmed ? (
                            <span className="color-light-green">
                                <Translate value="customRedlike.confirmed" />
                            </span>
                        ) : (
                            <Button
                                label={<Translate value="stock.confirmSendingOrder" />}
                                onClick={this.handleConfirmClick}
                            />
                        )}
                    </div>
                </div>
                <div className="col-12 flex flex-align-center">
                    <BarcodeImage id="manual-order-barcode-img" height="150vh" />
                </div>
            </React.Fragment>
        );
    };

    getSummary = () => {
        const rows = this.props.cart.colorantPackages.map((colorantPackageStock) =>
            modelHelper.buildTableRow([
                modelHelper.buildTableCell(
                    <span>
                        {colorantPackageStock.colorant}{" "}
                        <span className="color-light-blue font-0_75em">({colorantPackageStock.database})</span>
                    </span>
                ),
                modelHelper.buildTableCell(colorantPackageStock.value),
                modelHelper.buildTableCell(
                    colorantPackageStock.confirmed ? (
                        <span className="color-light-green">
                            <Translate value="general.yes" />
                        </span>
                    ) : (
                        <span className="color-light-red">
                            <Translate value="general.no" />
                        </span>
                    )
                )
            ])
        );

        const header = modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.colorant" />),
            modelHelper.buildTableCell(<Translate value="stock.toOrder" />),
            modelHelper.buildTableCell(<Translate value="customRedlike.confirmed" />)
        ]);

        const columns = [
            modelHelper.buildTableColumn("col-6"),
            modelHelper.buildTableColumn("col-3 text-center"),
            modelHelper.buildTableColumn("col-3 text-right")
        ];

        return <Table tableHeader={header} tableRows={rows} tableColumns={columns} variant={TABLE_VARIANT_SECONDARY} />;
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            this.state.step < this.props.cart.colorantPackages.length ? this.getColorantInfo() : this.getSummary(),
            "flex-column"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    className="flex-align-center min-width-150"
                    label={<Translate value="general.previous" />}
                    disabled={this.state.step === 0}
                    onClick={this.handlePreviousClick}
                />
                {this.state.step === this.props.cart.colorantPackages.length ? (
                    <Button
                        className="flex-align-center min-width-150 margin-left-10"
                        label={<Translate value="stock.sendConfirmed" />}
                        disabled={!this.props.cart.colorantPackages.find((cp) => cp.confirmed)}
                        onClick={this.handleSubmit}
                    />
                ) : (
                    <Button
                        className="flex-align-center min-width-150 margin-left-10"
                        label={<Translate value="general.next" />}
                        onClick={this.handleNextClick}
                    />
                )}

                <Button
                    className="flex-align-center min-width-150 margin-left-10"
                    label={<Translate value="general.cancel" />}
                    onClick={this.handleCloseModalClick}
                />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={this.getHeader()}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "55%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        cart: store.stock.cart,
        colorantPackages: store.stock.colorantPackages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseManualOrderStockModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MANUAL_ORDER_STOCK_MODAL));
        },
        dispatchGetBarcodeAction: ({colorant: colorant, package: pckg}) => {
            dispatch(barcodeActions.getColorantPackageBarcode(colorant, pckg));
        },
        dispatchSaveStockCartAction: (cart) => {
            dispatch(stockActions.saveCart(cart));
        },
        dispatchAddColorantPackagesOrdersAction: (colorantPackages) => {
            dispatch(stockActions.addColorantPackagesOrders(colorantPackages));
        }
    };
};

export default ManualOrderStockModal = connect(mapStoreToProps, mapDispatchToProps)(ManualOrderStockModal);
